import { MentorConversationRow } from './MentorMessagesService';
import { initialsFromName } from './mentorDashboardFormat';
import { formatMessageTime } from './mentorMessagesFormat';


const AVATAR_TONES = ['bg-primary bg-opacity-25', 'bg-warning-subtle', 'bg-primary-subtle', 'bg-warning', 'bg-danger-subtle'];

type Props = {
    rows: MentorConversationRow[];
    selectedUuid: string | null;
    disabled?: boolean;
    onSelect: (menteeUuid: string) => void;
};

const MentorMessagesList = ({ rows, selectedUuid, disabled, onSelect }: Props) => (
    <div className="col-md-3 border-end border-light-subtle d-flex flex-column bg-light bg-opacity-25" style={{maxHeight: '580px', overflowY: 'auto'}} aria-label="Conversations">
        <div className="p-3 border-bottom bg-white d-flex align-items-center justify-content-between">
            <span className="fw-bold text-dark font-14">Conversations</span>
            <span className="badge bg-danger rounded-pill font-11">1 unread</span>
        </div>
        
        {rows.length === 0 ? (
            <p className="mmmsg-muted">No assigned mentees.</p>
        ) : (
            <div className="list-group list-group-flush" id='chat-conversation-list'>
                {rows.map((row, index) => {
                    const uuid = row.mentee.menteeUuid;
                    const timeLabel = formatMessageTime(row.lastSentDate);
                    const preview = row.lastMessagePreview ? String(row.lastMessagePreview).trim() : '';
                    const selected = !!uuid && uuid === selectedUuid;
                    const tone = AVATAR_TONES[Math.abs(index) % AVATAR_TONES.length];
                    return (
                   
                            <button
                            key={uuid || row.mentee.pairId || row.mentee.menteeName || index}
                                type="button"
                                className={`list-group-item list-group-item-action d-flex gap-2 p-3 border-0 border-bottom border-light-subtle ${selected ? 'position-relative active bg-primary bg-opacity-10' : ''}`}
                                disabled={disabled || !uuid}
                                onClick={() => uuid && onSelect(uuid)}
                            >
                                <span className={`rounded-circle border border-primary border-opacity-25 flex-shrink-0 d-flex justify-content-center align-items-center font-600 text-dark ${tone}`} style={{width:'36px', height: '36px'}}>{initialsFromName(row.mentee.menteeName)}</span>
                                <div className="flex-grow-1 min-w-0">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="fw-bold font-13 text-dark text-truncate">{row.mentee.menteeName || 'Mentee'}</div>
                                        {timeLabel ? <div className="text-muted font-10">{timeLabel}</div> : null}
                                    </div>
                                    {preview ? <div className="text-secondary small mt-1 font-11 text-truncate">{preview}</div> : null}
                                </div>
                            </button>
                     
                    );
                })}
            </div>
        )}
    </div>
);

export default MentorMessagesList;
